// extracted by mini-css-extract-plugin
export default {"partItem":"style_partItem__m4eCj","active":"style_active__ffrjR"};